/* PawMoM — Crown-style homepage kit behaviour (2026-10-12).
   1. Tabs (ARIA tabs pattern, arrow/Home/End keys)
   2. Review track prev/next buttons
   3. Header search toggle (centred header layout)
   4. Floating offer button opens the existing email popup when it is on the page
   Re-initialises when sections are added/edited in the theme editor. */
(function () {
  'use strict';

  function initTabs(root) {
    root.querySelectorAll('[data-pmh-tabs]').forEach(function (sec) {
      if (sec.__pmhTabs) return;
      sec.__pmhTabs = true;
      var tabs = Array.prototype.slice.call(sec.querySelectorAll('[role="tab"]'));
      if (!tabs.length) return;

      function select(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (focus) tab.focus();
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(tab, false); });
        tab.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
          else if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
          else if (e.key === 'Home') n = tabs[0];
          else if (e.key === 'End') n = tabs[tabs.length - 1];
          if (n) { e.preventDefault(); select(n, true); }
        });
      });
    });
  }

  function initTracks(root) {
    root.querySelectorAll('[data-pmh-track]').forEach(function (track) {
      if (track.__pmhTrack) return;
      track.__pmhTrack = true;
      var sec = track.closest('section') || document;
      var prev = sec.querySelector('[data-pmh-prev]');
      var next = sec.querySelector('[data-pmh-next]');

      function step() {
        var card = track.firstElementChild;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        return card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); track.scrollBy({ left: step(), behavior: 'smooth' }); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); track.scrollBy({ left: -step(), behavior: 'smooth' }); }
      });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function initSearchToggle(root) {
    root.querySelectorAll('[data-pmh-search-toggle]').forEach(function (btn) {
      if (btn.__pmhSearch) return;
      btn.__pmhSearch = true;
      var header = btn.closest('.header');
      if (!header) return;
      var input = header.querySelector('.hdr-search-wrap input[type="search"]');

      function setOpen(open) {
        header.classList.toggle('is-search-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open && input) input.focus();
      }
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        setOpen(!header.classList.contains('is-search-open'));
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && header.classList.contains('is-search-open')) { setOpen(false); btn.focus(); }
      });
      document.addEventListener('click', function (e) {
        if (!header.classList.contains('is-search-open')) return;
        if (e.target.closest('.hdr-search-wrap') || e.target.closest('[data-pmh-search-toggle]')) return;
        setOpen(false);
      });
    });
  }

  function initFloat(root) {
    root.querySelectorAll('[data-pmh-float-popup]').forEach(function (a) {
      if (a.__pmhFloat) return;
      a.__pmhFloat = true;
      a.addEventListener('click', function (e) {
        if (document.querySelector('.pm-pop')) {
          e.preventDefault();
          document.dispatchEvent(new CustomEvent('pm:open-popup'));
        }
      });
    });
  }

  function init(root) {
    root = root || document;
    initTabs(root);
    initTracks(root);
    initSearchToggle(root);
    initFloat(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var tab = e.target.closest && e.target.closest('[role="tab"]');
    if (tab) tab.click();
  });
})();
